module.exports = __webpack_public_path__ + "static/media/logo-crecer-plee.105a5767.png";